<template>
    <div class="" v-if="items.length>0">
        <h2>Ответственные за реализацию проекта</h2>
        <table class="table">
            <thead>
            <tr>
                <th></th>
                <th>ФИО (полностью)</th>
                <th>Телефон</th>
                <th>Е-mail</th>
            </tr>
            </thead>
            <tbody>
            <tr v-bind:key="item.id" v-for="item in items">
                <td>
                    <span v-if="item.type">{{item.type}}</span>
                    <span v-else>{{item.post}}</span>
                </td>
                <td>{{item.name}}</td>
                <td>{{item.phone}}</td>
                <td>{{item.email}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
    import Request from 'superagent';
    export default{
        data(){
            return{
                eoId:null,
                items:[]
            };
        },


        created(){
            this.eoId = this.$store.state.eoId;
            this.getItems();
        },


        methods:{
            getItems(){
                var path = this.$store.state.api+ this.$store.state.apiCadetResponsible +"?eoId="+this.eoId;
                var $this = this;
                Request
                    .get(path)
                    .then(function(res){
                        if(res.status == 200){
                            if(res.body.result == "success"){
                                $this.items = res.body.data;
                            }
                        }
                    })
                ;
            }
        }
    }
</script>


<style></style>
